var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOdysseyAgent && _vm.isStaging && _vm.device === 'desktop')?_c('div',{staticClass:"bottom-right-phone-icon"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.showModal}},[_c('img',{staticClass:"img-call",attrs:{"src":_vm.phoneImage,"alt":"phone"}})]),_c('caller-info-modal')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }